import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-selection',
  templateUrl: './selection.component.html',
  styleUrls: ['./selection.component.sass']
})
export class SelectionComponent implements OnInit {

  submissions: any;
  selection: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.setSelection();
  }

  setSelection() {
    this.submissions = [
      { organisationName: 'No Health Board', 
        submissionName: 'Private Provider', 
        submissionId: 22369,
        organisationId: 232 
      },
      {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "The Grange University Hospital",
        submissionId: "22196",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "Nevill Hall Hospital",
        submissionId: "22197",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "Royal Gwent Hospital",
        submissionId: "22198",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "Ysbyty Aneurin Bevan",
        submissionId: "22199",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "Ysbyty Ystrad Fawr",
        submissionId: "22200",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "St. Woolos Hospital",
        submissionId: "22201",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "Chepstow Community Hospital",
        submissionId: "22202",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "County Hospital",
        submissionId: "22203",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "Monnow Vale Health & Social Care Facility",
        submissionId: "22204",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "Llanfrechfa Grange",
        submissionId: "22205",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "Cwm Coch Unit",
        submissionId: "22206",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "Maindiff Court Hospital",
        submissionId: "22207",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "St. Cadocs Hospital",
        submissionId: "22208",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "Talygarn Unit",
        submissionId: "22209",
        organisationId: "234"
    },
    {
        organisationName: "Aneurin Bevan University Health Board",
        submissionName: "Ysbyty'r Tri Chwm",
        submissionId: "22210",
        organisationId: "234"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Glan Clwyd Hospital",
        submissionId: "22211",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Wrexham Maelor Hospital",
        submissionId: "22212",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Ysbyty Gwynedd",
        submissionId: "22213",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Bryn Beryl Hospital",
        submissionId: "22214",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Denbigh Community Hospital",
        submissionId: "22215",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Dolgellau & Barmouth District Hospital",
        submissionId: "22216",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Holywell Community Hospital",
        submissionId: "22217",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Llandudno General Hospital",
        submissionId: "22218",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Mold Community Hospital",
        submissionId: "22219",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Tywyn Memorial Hospital",
        submissionId: "22220",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Ysbyty Alltwen",
        submissionId: "22221",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Ysbyty Penrhos Stanley",
        submissionId: "22222",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Abergele Clinic",
        submissionId: "22223",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Argyll Road Health Clinic",
        submissionId: "22224",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Bodelwyddan Clinic",
        submissionId: "22225",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Cerrigydrudion Clinic",
        submissionId: "22226",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Colwyn Bay Clinic",
        submissionId: "22227",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Conwy Health Clinic",
        submissionId: "22228",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Corwen Clinic",
        submissionId: "22229",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Denbigh Clinic",
        submissionId: "22230",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Fforddlas Health Centre",
        submissionId: "22231",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Kinmel Bay Clinic",
        submissionId: "22232",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Llysfaen Clinic",
        submissionId: "22233",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Mochdre Clinic",
        submissionId: "22234",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Plas Meddyg",
        submissionId: "22235",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Prestatyn Clinic",
        submissionId: "22236",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Rhos-On-Sea Clinic",
        submissionId: "22237",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Rhuddlan Clinic",
        submissionId: "22238",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Ruthin Clinic",
        submissionId: "22239",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "St Asaph Clinic",
        submissionId: "22240",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Tan-Y-Marian Clinic",
        submissionId: "22241",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Abergele Hospital",
        submissionId: "22242",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Amethyst SARC",
        submissionId: "22243",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Chirk Community Hospital",
        submissionId: "22244",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Colwyn Bay Community Hospital",
        submissionId: "22245",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Deeside Community Hospital",
        submissionId: "22246",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Eryri Hospital",
        submissionId: "22247",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Royal Alexandra Hospital",
        submissionId: "22248",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Ruthin Community Hospital",
        submissionId: "22249",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Cefni Hospital",
        submissionId: "22250",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Hafod Mental Health Resource Centre",
        submissionId: "22251",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Nant y Glyn Community Mental Health Team",
        submissionId: "22252",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Ablett Unit",
        submissionId: "22253",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Bodnant EMI Unit",
        submissionId: "22254",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Bryn Hesketh Unit",
        submissionId: "22255",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Glan Traeth",
        submissionId: "22256",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "North Wales Adolescent Service",
        submissionId: "22257",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Bryn y Neuadd Hospital",
        submissionId: "22258",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "North Wales Cancer Treatment Centre",
        submissionId: "22259",
        organisationId: "8"
    },
    {
        organisationName: "Betsi Cadwaladr University Health Board",
        submissionName: "Wrexham Local Committee",
        submissionId: "22260",
        organisationId: "8"
    },
    {
        organisationName: "Cardiff & Vale University Health Board",
        submissionName: "University Hospital of Wales",
        submissionId: "22261",
        organisationId: "140"
    },
    {
        organisationName: "Cardiff & Vale University Health Board",
        submissionName: "Barry Hospital",
        submissionId: "22262",
        organisationId: "140"
    },
    {
        organisationName: "Cardiff & Vale University Health Board",
        submissionName: "Cardiff Royal Infirmary",
        submissionId: "22263",
        organisationId: "140"
    },
    {
        organisationName: "Cardiff & Vale University Health Board",
        submissionName: "Children's Hospital for Wales",
        submissionId: "22264",
        organisationId: "140"
    },
    {
        organisationName: "Cardiff & Vale University Health Board",
        submissionName: "St. Davids Hospital (Cardiff)",
        submissionId: "22265",
        organisationId: "140"
    },
    {
        organisationName: "Cardiff & Vale University Health Board",
        submissionName: "University Hospital Llandough",
        submissionId: "22266",
        organisationId: "140"
    },
    {
        organisationName: "Cardiff & Vale University Health Board",
        submissionName: "Whitchurch Hospital",
        submissionId: "22267",
        organisationId: "140"
    },
    {
        organisationName: "Cardiff & Vale University Health Board",
        submissionName: "Rookwood Hospital",
        submissionId: "22268",
        organisationId: "140"
    },
    {
        organisationName: "Cardiff & Vale University Health Board",
        submissionName: "University Dental Hospital",
        submissionId: "22269",
        organisationId: "140"
    },
    {
        organisationName: "Cwm Taf Morgannwg University Local Health Board",
        submissionName: "Prince Charles Hospital",
        submissionId: "22270",
        organisationId: "152"
    },
    {
        organisationName: "Cwm Taf Morgannwg University Local Health Board",
        submissionName: "Princess of Wales Hospital",
        submissionId: "22271",
        organisationId: "152"
    },
    {
        organisationName: "Cwm Taf Morgannwg University Local Health Board",
        submissionName: "Royal Glamorgan Hospital",
        submissionId: "22272",
        organisationId: "152"
    },
    {
        organisationName: "Cwm Taf Morgannwg University Local Health Board",
        submissionName: "Ysbyty Cwm Cynon",
        submissionId: "22273",
        organisationId: "152"
    },
    {
        organisationName: "Cwm Taf Morgannwg University Local Health Board",
        submissionName: "Ysbyty Cwm Rhondda",
        submissionId: "22274",
        organisationId: "152"
    },
    {
        organisationName: "Cwm Taf Morgannwg University Local Health Board",
        submissionName: "Pontypridd & District Cottage Hospital (Y Bwthyn)",
        submissionId: "22275",
        organisationId: "152"
    },
    {
        organisationName: "Cwm Taf Morgannwg University Local Health Board",
        submissionName: "Dewi Sant Hospital",
        submissionId: "22276",
        organisationId: "152"
    },
    {
        organisationName: "Cwm Taf Morgannwg University Local Health Board",
        submissionName: "Maesteg Community Hospital",
        submissionId: "22277",
        organisationId: "152"
    },
    {
        organisationName: "Cwm Taf Morgannwg University Local Health Board",
        submissionName: "Ysbyty George Thomas",
        submissionId: "22278",
        organisationId: "152"
    },
    {
        organisationName: "Cwm Taf Morgannwg University Local Health Board",
        submissionName: "Glanrhyd Hospital",
        submissionId: "22279",
        organisationId: "152"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Bronglais General Hospital",
        submissionId: "22280",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Glangwili General Hospital",
        submissionId: "22281",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Withybush General Hospital",
        submissionId: "22282",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Cardigan Integrated Care Centre",
        submissionId: "22283",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Llandovery Hospital",
        submissionId: "22284",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Prince Philip Hospital",
        submissionId: "22285",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Tenby Walk-in Centre",
        submissionId: "22286",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Aberaeron Integrated Care Centre",
        submissionId: "22287",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Amman Valley Hospital",
        submissionId: "22288",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "South Pembrokeshire Hospital",
        submissionId: "22289",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Tregaron Hospital",
        submissionId: "22290",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Brynmair Clinic Day Hospital",
        submissionId: "22291",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Gorwelion Day Hospital",
        submissionId: "22292",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Swn-y-Gwynt Day Hospital",
        submissionId: "22293",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Bro Cerwyn / St Brynach Day Hospitals",
        submissionId: "22294",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Cwm Seren, Tudor House & Ty Bryn",
        submissionId: "22295",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Ceredigion Local Committee",
        submissionId: "22296",
        organisationId: "376"
    },
    {
        organisationName: "Hywel Dda University Health Board",
        submissionName: "Carmarthenshire Local Committee",
        submissionId: "22297",
        organisationId: "376"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Hereford County Hospital",
        submissionId: "22298",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Princess Royal Hospital (England)",
        submissionId: "22299",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Royal Shrewsbury Hospital (England)",
        submissionId: "22300",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Brecon War Memorial Hospital",
        submissionId: "22301",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Llandrindod Wells County War Memorial Hospital",
        submissionId: "22302",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Ludlow Community Hospital (England)",
        submissionId: "22303",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Oswestry Health Centre (England)",
        submissionId: "22304",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Victoria Memorial Hospital",
        submissionId: "22305",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Ystradgynlais Community Hospital",
        submissionId: "22306",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Bronllys Hospital",
        submissionId: "22307",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Glan Irfon Health and Social Care Centre (Builth Wells)",
        submissionId: "22308",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Knighton Hospital",
        submissionId: "22309",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Llanidloes War Memorial Hospital",
        submissionId: "22310",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Machynlleth Community Hospital (Bro Ddyfi)",
        submissionId: "22311",
        organisationId: "272"
    },
    {
        organisationName: "Powys Local Health Board",
        submissionName: "Montgomery County Infirmary",
        submissionId: "22312",
        organisationId: "272"
    },
    {
        organisationName: "Swansea Bay University Health Board",
        submissionName: "Morriston Hospital",
        submissionId: "22313",
        organisationId: "2"
    },
    {
        organisationName: "Swansea Bay University Health Board",
        submissionName: "Neath Port Talbot Hospital",
        submissionId: "22314",
        organisationId: "2"
    },
    {
        organisationName: "Swansea Bay University Health Board",
        submissionName: "Gorseinon Hospital",
        submissionId: "22315",
        organisationId: "2"
    },
    {
        organisationName: "Swansea Bay University Health Board",
        submissionName: "Cimla Hospital",
        submissionId: "22316",
        organisationId: "2"
    },
    {
        organisationName: "Swansea Bay University Health Board",
        submissionName: "Gellinudd Hospital",
        submissionId: "22317",
        organisationId: "2"
    },
    {
        organisationName: "Swansea Bay University Health Board",
        submissionName: "Singleton Hospital",
        submissionId: "22318",
        organisationId: "2"
    },
    {
        organisationName: "Swansea Bay University Health Board",
        submissionName: "Llwyneryr Unit",
        submissionId: "22319",
        organisationId: "2"
    },
    {
        organisationName: "Swansea Bay University Health Board",
        submissionName: "Cefn Coed Hospital",
        submissionId: "22320",
        organisationId: "2"
    },
    {
        organisationName: "Swansea Bay University Health Board",
        submissionName: "Garngoch Hospital",
        submissionId: "22321",
        organisationId: "2"
    },
    {
        organisationName: "Swansea Bay University Health Board",
        submissionName: "Local Primary Mental Health Support Services, Tonna Resource Centre",
        submissionId: "22322",
        organisationId: "2"
    },
    {
        organisationName: "Swansea Bay University Health Board",
        submissionName: "Tonna Hospital",
        submissionId: "22323",
        organisationId: "2"
    }
    ]
  }

}
